import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { Header } from "shared/components/organisms/Header/Header";
import { Sidebar } from "shared/components/organisms/Sidebar/Sidebar";
import { DateFilterModal } from "shared/components/molecules/DateFilterModal/DateFilterModal";
import { ServicesFilterModal } from "shared/components/molecules/ServicesFilterModal/ServicesFilterModal";
import { SelectFilter } from "shared/components/molecules/SelectFilter/SelectFilter";
import { WithdrawModal } from "shared/components/organisms/WithdrawModal/WithdrawModal";

import { ReactComponent as LeftArrow } from 'assets/icons/left-arrow.svg'
import Dolar from 'assets/icons/circular-dolar-icon.svg';
import OpenEye from 'assets/icons/open-eye-icon.svg';
import CloseEye from 'assets/icons/close-eye-icon.svg';

import api from "services/api";

import { parseDate } from "utils/parseDate";

import { Container, Content, GainsSection, ReturnButton } from "./_gains";
import { parseCurrencyInCents } from "utils/format";

interface ITransaction {
  provider_done: boolean;
  customer_done: boolean;
  date: string;
  service_solicitation_id: string;
  provider_id: string;
  user_id: string;
  transaction_id: string;
  address_id: string;
  code: string;
  id: string;
  status_id: string;
  service_type_id: string;
  provider_started_at: string;
  provider_dont_started_at: string;
  provider_dont_started_notified: boolean;
  canceled_at: string;
  user: {
    id: string;
    email: string;
    is_active: boolean;
    avatar: string;
    role_id: string;
    average_rating: string;
    geolocation: string;
    individual_person: {
      id: string;
      name: string;
      cpf: string;
      user_id: string;
      born_at: string;
    },
    avatar_url: string;
  },
  service_type: {
    id: string;
    name: string;
    description: string;
    is_active: boolean;
    base_price: number;
    category_id: string;
    order: string;
    category: {
      id: string;
      name: string;
      icon: string;
      is_active: boolean;
      order: string;
    },
  },
  provider: {
    id: string;
    user_id: string;
    recipient_id: string;
    auto_withdraw: boolean;
    on_loop: boolean;
    is_working: boolean;
    type: string;
    is_working_updated_at: string;
    banned: boolean;
    number_of_errors_when_verifying_cpf: string;
    average_rating: string;
    user: {
      id: string;
      email: string;
      is_active: boolean;
      avatar: string;
      role_id: string;
      average_rating: string;
      geolocation: string;
      individual_person: {
        id: string;
        name: string;
        cpf: string;
        user_id: string;
        born_at: string;
      },
      avatar_url: string;
    },
    working_on_appointment_id: string;
  },
  transaction: {
    id: string;
    value: string;
    coupon_id: string;
    external_id: string;
    status_id: string;
    split_percentage: string;
    user_id: string;
    payment_type_id: string;
    provider_split_rule_id: string;
    repfy_split_rule_id: string;
    card_last_digits: string;
    refunded: boolean
    created_at: string;
    updated_at: string;
  },
  service_solicitation: {
    id: string;
    date: string;
    price: string;
    product_id: string;
    address_id: string;
    user_id: string;
    transaction_id: string;
    canceled: boolean,
    status_id: string;
    canceled_at: string;
    service_type_id: string;
  }
}

export const Gains = () => {
  const [showValue, setShowValue] = useState(false)

  const [filterQuery, setFilterQuery] = useState('')
  const [showFilterModal, setShowFilterModal] = useState({
    total: true,
    date: false,
    services: false,
  })

  const [showWithdrawModal, setShowWithdrawModal] = useState(false);

  const [transactions, setTransactions] = useState([] as ITransaction[])
  const [gains, setGains] = useState<string>();
  const [toReceive, setToReceive] = useState<string>();

  const toggleValue = () => {
    setShowValue(prevState => !prevState)
  }

  const handleOpenWithdrawModal = () => {
    setShowWithdrawModal(true);
  }

  const ensureTransactions = async () => {
    try {
      const response: any = await api.get(`/appointments?${filterQuery}`,{
        params: {
          provider_done: true,
          costumer_done: true,
        }
      })
      const appointments = response?.data?.service_appointments

      setTransactions(appointments)
    } catch (error: any) {
      toast.error(error?.response?.data?.error || 'Opps algo deu errado, tente novamente mais tarde!')
    }
  }

  useEffect(() => {
    ensureTransactions()
  },[filterQuery])

  const ensureGains = async () => {
    try {
      const response: any = await api.get('/providers/balance')

      const amount = parseCurrencyInCents(response?.data?.balance?.available?.amount || '0')

      setGains(amount);
      setToReceive(parseCurrencyInCents(response?.data?.balance?.waiting_funds?.amount) || '0');
    } catch (error: any) {
      toast.error(error?.response?.data?.error || 'Opps algo deu errado, tente novamente mais tarde!')
    }
  }

  useEffect(() => {
    ensureGains()
  },[])
  
  const total = transactions.reduce((acc, transaction) => {
    return acc + parseFloat(transaction.service_solicitation.price) / 100;
  }, 0) * 0.97;
  
  const formattedTotal = total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  
  return (
    <Container>
      <Header />
      <Sidebar />

      <Content>
        <ReturnButton to="/perfil">
          <LeftArrow
            className="gains__content-icon"
          />
        </ReturnButton>

        <GainsSection>
          <div className="gains__wallet-wrapper">
            <h1 className="gains__wallet-title">
              Minha carteira:
            </h1>
            <article
              className="gains__wallet"
            >
              <img
                src={Dolar}
                alt="Dolar"
                className="gains__wallet-icon"
              />
              <div className="gains__wallet-content">
                <h2 className="gains__wallet-content__title">
                  Minha carteira
                </h2>
                <p className="gains__wallet-content__subtitle">
                  Total a sacar:
                </p>
                <h1 className="gains__wallet-content__value">
                  {showValue ? gains : '__ __ __'}
                </h1>
                {showValue ? (
                  <>
                    <p className="gains__wallet-content__subsubtitle">
                      Total a receber:
                    </p>
                    <h1 className="gains__wallet-content__subvalue">
                      {toReceive}
                    </h1>
                  </>
                ): null}

                <button
                  type="button"
                  className="gains__wallet-content__button"
                  onClick={handleOpenWithdrawModal}
                >
                  Sacar
                </button>
                <button
                  type="button"
                  className={
                    "gains__wallet-content__view-button"
                    + (showValue
                      ? ''
                      : '--closed'
                    )
                  }
                  onClick={toggleValue}
                >
                  <img
                    src={showValue ? OpenEye : CloseEye}
                    alt="View value"
                    className="gains__wallet-content__view"
                  />
                </button>
              </div>
            </article>
          </div>
          <section className="gains__historic">
            <h1 className="gains__historic-title">
              Histórico de faturamento
            </h1>
            <article className="gains__historic-filter-container">
              <SelectFilter
                className="gains__historic-filter"
                {...{setFilterQuery, setShowFilterModal}}
              />
              <p className="gains__historic-filter-total">
                Valor total:
                <br />
                <b className="gains__historic-filter-total-b">
                  {showValue ? formattedTotal : '__ __ __'}
                </b>
              </p>
            </article>
            <h2 className="gains__receipt-title">
              Recebidos
            </h2>
            <ul className="gains__receipt-ul">
              {transactions.map((transaction) => (
                <li key={transaction?.transaction?.id} className="gains__receipt-li">
                  <article className="gains__receipt-article">
                    <img src="" alt="" />
                    <div className="gains__receipt-article__content">
                      <h1 className="gains__receipt-article__title">
                        {transaction?.service_type?.name} - {transaction?.user?.individual_person?.name}
                      </h1>
                      <p className="gains__receipt-article__info">
                        Dia {parseDate(transaction?.transaction?.updated_at)}
                      </p>
                      <p className="gains__receipt-article__info">
                        Valor do Serviço:
                        {' '}
                        {parseCurrencyInCents(transaction?.transaction?.value)}
                      </p>
                      <span className="gains__receipt-article__n">Nº{transaction.code}</span>
                    </div>
                  </article>
                </li>
              ))}
            </ul>
            {transactions?.length < 1 && (
              <h1 className="gains__receipt-info">Nenhuma transação registrada!</h1>
            )}
          </section>
          {showFilterModal.date && (
            <DateFilterModal
              toggleModal={setShowFilterModal}
              setFilterQuery={setFilterQuery}
            />
          )}
          {showFilterModal.services && (
            <ServicesFilterModal
              toggleModal={setShowFilterModal}
              setFilterQuery={setFilterQuery}
            />
          )}
          {
            showWithdrawModal && (
              <WithdrawModal
                toggleModal={setShowWithdrawModal}
              />
            )
          }
        </GainsSection>
      </Content>
    </Container>
  );
};